var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","id":"importFile","accept":".json"},on:{"change":_vm.handleImport}}),_c('VuePrint')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }